<template>
  <div class="updata-list">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="50"
    >
      <ul class="list">
        <li
          v-for="item in Content"
          :key="item.id"
          @click="$router.push('/lesson-detail/' + item.id)"
        >
          <div class="img-content">
            <img :src="item.cover_img" alt="" />
            <div class="info">
              <div class="teacher-name">{{item.teacher}}</div>
              <div class="play-num">{{item.play_num}}</div>
            </div>
          </div>
          <div class="title o1">{{ item.title }}</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "updata-list",
  data() {
    return {
      loading: false,
      finished: false,
      start: 0,
      len: 10,
      Content: []
    };
  },
  methods: {
    onLoad() {
      this.getlist();
      this.start+=this.len;
    },
    getlist() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/last_update",
          start: this.start,
          len: this.len
        },
        res => {
          if (res.status === 1) {
            this.loading = false;
            if (res.data.list.length > 0) {
              this.Content = this.Content.concat(res.data.list);
              this.finished = false;
            } else {
              this.finished = true; // 结束加载状态
            }
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.updata-list {
  padding: 0.4rem;
  box-sizing: border-box;
}
.updata-list *{
    box-sizing: border-box;
}
.updata-list ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.4rem;
}
.updata-list ul li{
    width: 4.4rem;
}
.updata-list ul .img-content {
  position: relative;
  width: 100%;
  height: 2.92rem;
  border-radius: 0.213rem;
  overflow: hidden;
}
.updata-list ul .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.updata-list ul .img-content .info {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.747rem;
  line-height: 0.747rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 0 0.213rem;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  font-size: 0.32rem;
}
.updata-list ul .title {
  width: 100%;
  padding: 0 0.213rem;
  margin-top: 0.24rem;
  line-height: 0.4rem;
  font-size: 0.4rem;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/updata-list/updata-list.vue